import { openEndedVisibilityFormSchema } from "shared/form/visibilitySchema";
import { z } from "zod";
import { customTextSchema } from "features/CenterContent/RoleContent/GlobalEvents/types/responseSchema";

export type GlobalVisibilityFormSchema = z.infer<
  typeof openEndedVisibilityFormSchema
>;

export const globalEventFormSchema = z.object({
  customTexts: customTextSchema,
  visibility: openEndedVisibilityFormSchema,
  incidentIds: z.array(z.string()),
});

export const globalFormSchema = z.object({
  globalForm: globalEventFormSchema,
});

export type GlobalFormSchema = z.infer<typeof globalFormSchema>;
